import { Box, Divider, Switch } from '@material-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import { FB } from '..';
import { translate } from '../../../common/intl';
import { DEVIATION_HIDE_KEY } from './FBDeviationProcedure.constants';
import useDeviationProcedureStyles from './FBDeviationProcedure.styles';

// "Show/Hide Deviation Changes" switch of an LHR step without a deviated procedure (FBSchema renders it above
// the first component the deviation added); same state as the procedure's switch (FBMPIProcedure)
const FBDeviationToggle: React.FC = () => {
  const classes = useDeviationProcedureStyles();
  const { workspaceState } = FB.useStores();
  const hidden = useObserver(() => Boolean(workspaceState?.formInputSync.get(DEVIATION_HIDE_KEY)));

  return (
    <Box className={classes.stepToggle}>
      <Box className={classes.stepToggleRow}>
        <Switch
          checked={!hidden}
          onChange={() => workspaceState?.formInputSync.set(DEVIATION_HIDE_KEY, !hidden)}
          color="primary"
          size="small"
        />
        <span className={classes.stepToggleLabel}>
          {translate(hidden ? 'lhrDeviation.changes.show' : 'lhrDeviation.changes.hide')}
        </span>
      </Box>
      <Divider />
    </Box>
  );
};

export default FBDeviationToggle;
